export default __webpack_public_path__ + "static/media/care-credit-card.8dec3607.png";